export const EMPTY_STRING = ''
export const SPACE_STRING = ' '
export const UNDERSCORE_STRING = '_'
export const EMPTY_ARRAY: any[] = []
export const SPECIAL_CHARS_REGEX = /[^a-zA-z0-9\s]/

export const SPACES_REGEX = /\s/g

export const SLASH_REGEX = /\//g

export const HTTPS_PREFIX = 'https://'

export const FILE_EXTENSION_IN_URL_REGEX = /(.*?)(\.[^.]+)?$/

export const DEFAULT_ID_SEPARATOR = ':::'

export const RUPEES_SYMBOL_STRING = '₹'

export const HYPHEN_STRING = '-'
